import { Component, inject } from '@angular/core';
import { OffshorePositionAndWeatherFormStore } from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-weather-effect',
  templateUrl: './weather-effect.component.html',
})
export class WeatherEffectComponent {
  readonly posAndWeathStore = inject(OffshorePositionAndWeatherFormStore);
}
